import React from 'react';
import { useSlate } from 'slate-react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';
import cx from 'classnames';
import { omit } from 'lodash';
import {
  isBlockStyleActive,
  toggleStyle,
} from '@redturtle/volto-rt-slate/config/Slate/Dropdown/dropdownUtils';

import { Icon } from '@plone/volto/components';
import { ToolbarButton } from '@plone/volto-slate/editor/ui';

import circleMenuSVG from '@plone/volto/icons/circle-menu.svg';
import menuSVG from '@plone/volto/icons/menu.svg';
import ctaArrowSVG from '@redturtle/volto-io-studio/icons/button-arrow.svg';

import '@redturtle/volto-rt-slate/config/Slate/Dropdown/dropdownStyle.css';

const messages = defineMessages({
  button: { id: 'Button', defaultMessage: 'Bottone' },
  primary: {
    id: 'Primary',
    defaultMessage: 'Primario',
  },
  outline: {
    id: 'Outline',
    defaultMessage: 'Bordo',
  },
  wide: {
    id: 'Wide',
    defaultMessage: 'A tutta larghezza',
  },
  arrow_right: {
    id: 'Arrow right',
    defaultMessage: 'Freccia a destra',
  },
  subsite_color: {
    id: 'Subsitee color',
    defaultMessage: 'Colore di accento',
  },
});

const OPTIONS = [
  {
    title: messages.primary,
    cssClass: 'ui button vis--button vis--button-primary',
    //icon: menuSVG,
    children: (
      <div className="ui button vis--button vis--button-primary">
        <Icon name={menuSVG} size="14px" color="white" />
      </div>
    ),
    oneOf: true,
  },
  {
    title: messages.outline,
    cssClass: 'ui button vis--button vis--button-outline',
    //icon: menuSVG,
    children: (
      <div className="ui button vis--button vis--button-outline">
        <Icon name={menuSVG} size="14px" />
      </div>
    ),
    oneOf: true,
  },
  {
    title: messages.subsite_color,
    cssClass: 'ui button vis--button vis--button-subsite',
    //icon: menuSVG,
    children: (
      <div className="ui button vis--button vis--button-subsite">
        <Icon name={menuSVG} size="14px" />
      </div>
    ),
    oneOf: true,
  },
  {
    title: messages.wide,
    cssClass: 'wide',
    //icon: menuSVG,
    children: (
      <div className="ui button vis--button wide">
        <Icon name={menuSVG} size="12px" />
      </div>
    ),
    oneOf: false,
  },
  {
    title: messages.arrow_right,
    cssClass: 'arrow-button',
    //icon: menuSVG,
    children: (
      <div className="ui button vis--button">
        <Icon className="arrow-button" name={ctaArrowSVG} size="12px" />
      </div>
    ),
    oneOf: false,
  },
];

const LinkButtonMenuButton = ({ icon, active, ...props }) => {
  return (
    <ToolbarButton
      {...props}
      icon={icon}
      active={active}
      onMouseDown={() => {}}
    />
  );
};

const MenuOpts = ({ editor, toSelect, option, type, ...props }) => {
  const isActive = toSelect.includes(option);

  return (
    <Dropdown.Item
      as="span"
      active={isActive}
      className={cx(`${type}-${option.value} ui button ${option.value}`, {
        active: isActive,
      })}
      {...omit(option, ['isBlock', 'originalIcon'])}
      data-isblock={option.isBlock}
      onClick={(event, selItem) => {
        toggleStyle(editor, {
          cssClass: selItem.value,
          isBlock: option.isBlock,
          oneOf: option.oneOf
            ? OPTIONS.reduce((acc, o) => [...acc, o.cssClass], [])
            : null,
        });
      }}
    />
  );
};

const LinkButtonButton = (props) => {
  const editor = useSlate();
  const intl = useIntl();

  const blockOpts = OPTIONS.map((def) => {
    return {
      value: def.cssClass,
      text: def.text,
      title: intl.formatMessage(def.title),
      icon: (props) => <Icon name={def.icon} size="24px" />,
      children: def.children,
      isBlock: false,
      originalIcon: def.icon,
      oneOf: def.oneOf,
    };
  });

  // Calculating the initial selection.
  const toSelect = [];
  let selectedIcon = circleMenuSVG;

  const oneOf = OPTIONS.reduce((acc, o) => [...acc, o.cssClass], []);

  // block styles
  for (const val of blockOpts) {
    const ia = isBlockStyleActive(editor, val.value, val.oneOf ? oneOf : null);

    if (ia) {
      toSelect.push(val);
      selectedIcon = val.originalIcon ?? selectedIcon;
    }
  }

  const menuItemProps = {
    toSelect,
    editor,
  };

  return (
    <Dropdown
      id="button-style-menu"
      pointing="top left"
      multiple
      value={toSelect}
      additionLabel={intl.formatMessage(messages.button)}
      trigger={
        <LinkButtonMenuButton
          title={intl.formatMessage(messages.button)}
          icon={selectedIcon}
          active={toSelect.length > 0}
        />
      }
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Dropdown.Menu>
        {blockOpts.length &&
          blockOpts.map((option, index) => (
            <MenuOpts
              {...menuItemProps}
              type="button-style"
              option={option}
              key={index}
            />
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LinkButtonButton;
